export {default as ReminderForm} from './ReminderForm.connect';
